import Header from "../../components/header"
import Sidebar from '../../components/sidebar'
import {
    AdminBody,
    AdminContent,
    PageTitle
} from './adminElements'
import { Switch, Route } from 'react-router-dom'
import NewsTable from "../../components/newsTable"
import NewsForm from "../../components/newsForm"
import Footer from "../../components/footer"

const Admin = ({match}) => {

    return (
        <>
            <Header hide />
            <AdminBody>
                    {
                        <Switch>
                            <Route exact path={`${match.url}/news`}>
                                <Sidebar />
                                <AdminContent>
                                    <PageTitle>Danh sách bài viết</PageTitle>
                                    <NewsTable />
                                </AdminContent>
                            </Route>
                            <Route exact path={`${match.url}/news/create`} >
                                <Sidebar />
                                
                                <AdminContent>
                                    <PageTitle>Thêm bài viết</PageTitle>
                                    <NewsForm />
                                </AdminContent>
                            </Route>
                            <Route exact path={`${match.url}/news/:id/edit`} >
                                <Sidebar type="edit" />
                                
                                <AdminContent>
                                <PageTitle>Chỉnh sửa bài viết</PageTitle>
                                <NewsForm type="update" />
                                </AdminContent>
                            </Route>
                            <Route exact path={`${match.url}/:string`}>
                                <h1>NOT FOUND</h1>
                            </Route>
                            <Route>
                            <h1>NOT FOUND</h1>
                            </Route>
                        </Switch>
                    }
                
            </AdminBody>
            <Footer />
        </>
    )
}

export default Admin
